module.exports = __webpack_public_path__ + "assets/img/title-5a739d1a.png";